<template>
  <div class="modal-parent">
    <div
      id="simple-feedback-modal"
      v-shortkey="['esc']"
      class="modal modal--small"
      @shortkey="closeModal"
    >
      <div class="modal_topbar">
        <div class="modal_topbar-title">
          {{ modalTitle }}
        </div>
        <span
          id="exit-feedback-modal"
          class="modal_topbar-exit"
          @click="closeModal"
          v-html="closeIcon"
        />
      </div>
      <div class="feedback-container">
        <div class="feedback-score">
          <template v-for="feedbackScore in feedbackScores">
            <div
              :id="feedbackScore.title + 'rating-feedback-modal'"
              :key="feedbackScore.score"
              v-tooltip="{ content: feedbackScore.title }"
              :class="[isSelected(feedbackScore.score), 'feedback-score__icon']"
              @click="setScore(feedbackScore.score)"
            >
              <img :src="feedbackScore.icon" />
            </div>
          </template>
        </div>
      </div>
      <div class="feedback-container">
        <p class="feedback-label">
          Thank you for using BioConnect Link. This survey only needs to be completed
          <strong>one time</strong> when adding a user <strong>and</strong> when adding a device.
          Your input matters!
        </p>
        <textarea
          id="textarea-feedback-modal"
          v-model="feedback.comment"
          class="feedback-textarea"
          placeholder="We'd love to hear any feedback you may have. (Optional)"
        />
      </div>
      <div class="modal_footer modal_footer--right">
        <button
          id="submit-feedback-modal"
          class="btn"
          :disabled="feedback.score === 0 || loading"
          @click="submitFeedback"
        >
          Submit Feedback
        </button>
      </div>
    </div>
    <div class="modal-overlay" />
  </div>
</template>

<script>
import {ENV} from '../config'
import axios from 'axios'

import goodIcon from '@/assets/good.png'
import badIcon from '@/assets/bad.png'

import feather from 'feather-icons'

export default {
  name: 'SimpleFeedbackModal',
  data() {
    return {
      loading: false,
      modalTitle: 'How was your experience?',
      closeIcon: feather.icons.x.toSvg(),
      feedback: {
        score: 0,
        comment: '',
      },
      feedbackScores: [
        {
          score: 1,
          icon: badIcon,
          title: 'Unsatisfactory',
        },
        {
          score: 5,
          icon: goodIcon,
          title: 'Good',
        },
      ],
    }
  },
  methods: {
    setScore(score) {
      this.feedback.score = score === this.feedback.score ? 0 : score
    },
    isSelected(score) {
      if (this.feedback.score === score) {
        return 'feedback-score__icon--selected'
      }
    },
    createHubspotPayload() {
      const {score, comment} = this.feedback
      const _payload = {
        submittedAt: new Date(),
        context: {
          pageUri: window.location.href,
          pageName: document.title,
        },
        fields: [
          {name: 'email', value: this.getUsername()},
          {name: 'feedback___happy___sad', value: score},
          {name: 'comments', value: comment},
        ],
      }
      return _payload
    },
    submitFeedback() {
      this.loading = true
      const _hubspotPath = 'https://api.hsforms.com/submissions/v3/integration/submit'
      const _path = `${_hubspotPath}/${ENV.hubspot_portal_id}/${ENV.hubspot_form_id}`
      const _payload = this.createHubspotPayload()

      axios({
        url: _path,
        method: 'post',
        data: JSON.stringify(_payload),
        headers: {'Content-Type': 'application/json'},
      })
        .then((result) => {
          this.closeModal()
          this.displayAlert('success', 'Your feedback is greatly appreciated!')
          this.emitFeedbackSent()
        })
        .catch((error) => {
          this.displayAlert('fail', 'Unable to submit feedback.')
          console.log('Not Submited', error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    emitFeedbackSent() {
      this.$emit('feedbackSent')
    },
    closeModal() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.feedback {
  &-container {
    @include flex-display();
    @include flex-direction(column);
    width: 100%;
    margin: 1em 0;
  }
  &-label {
    margin-top: 0;
  }
  &-score {
    @include flex-display();
    @include flex-justify-content(space-evenly);
    &__icon {
      @include flex-display();
      @include flex-justify-content(center);
      @include flex-align-items(center);
      background: transparent;
      width: 100px;
      height: 100px;
      font-size: 1.5em;
      border-radius: 50%;
      img {
        @include transition(all 0.5s ease-out);
        width: 70%;
      }
      &:hover {
        cursor: pointer;
        img {
          filter: drop-shadow(0 0 10px $yellow);
          @include transform(scale(1.2));
        }
      }
      &--selected {
        img {
          filter: drop-shadow(0 0 10px $blue) !important;
          @include transform(scale(1.2));
        }
      }
    }
  }
  &-select {
    padding: 1em;
    border: 1px solid $light-grey;
    border-radius: 5px;
    background: $off-white;
    font-size: 1em;
  }

  &-textarea {
    font-family: sans-serif;
    font-weight: normal;
    padding: 1em;
    border-radius: 5px;
    border: 1px solid $light-grey;
    &:focus {
      outline: none;
      border-color: $blue;
    }
  }
}
</style>
